<template>
  <van-overlay show class-name="breakpoint overflow-y-auto" z-index="1000">
    <div class="h-full bg-white text-center breakpoint-container">
      <img src="/assets/img/gray-logo.png" alt="" width="128" />
      <div class="mb-6 mt-3" style="line-height: 24px">
        <div>问卷已更新</div>
        <div>点击 <span class="text-theme cursor-pointer inline-block" @click="onRestart">重新开始</span> 重新答题</div>
      </div>
      <div class="py-6">
        <van-button class="mt-3" block @click="onRestart">重新开始</van-button>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'OverlayRestart',
  methods: {
    onRestart() {
      this.$emit('restart')
    }
  }
}
</script>

<style scoped lang="scss">
.breakpoint-container {
  padding: 10vh 64px 0;
  box-sizing: border-box;
}
</style>
